module.exports = __webpack_public_path__ + "img/LogoSSBG.f216826a.png";